import { Stack, Box, LinearProgress } from '@mui/material';
import React from 'react';
type AppLoaderGraphProps = {
	height?: number;
};
const AppLoaderGraph = (props: AppLoaderGraphProps) => {
	const { height } = props;
	return (
		<Stack
			sx={{ width: '50%', margin: 'auto', height: height ? `${height}px` : '', textAlign: 'center' }}
			alignContent="center"
			justifyContent="center"
		>
			<Box>
				<Box color="primary" sx={{ fontSize: '1rem', fontWeight: 300, marginBottom: '10px' }}>
					Loading ...
				</Box>
				<LinearProgress color="secondary" />
			</Box>
		</Stack>
	);
};

export default AppLoaderGraph;
